import { render, staticRenderFns } from "./StorageCardShimmer.vue?vue&type=template&id=6038cc00&scoped=true&"
import script from "./StorageCardShimmer.vue?vue&type=script&lang=js&"
export * from "./StorageCardShimmer.vue?vue&type=script&lang=js&"
import style0 from "./StorageCardShimmer.vue?vue&type=style&index=0&id=6038cc00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6038cc00",
  null
  
)

export default component.exports